import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { CommonService } from 'src/app/services/Common-function/common.service';
import { InfoTerm } from 'src/app/components/shared/popups/info-dialog/info-dialog.component';
import { METRIC_GLOSSARY } from 'src/app/components/shared/popups/info-dialog/metric-info';

/**
 * Reusable "Learn Terms" button used across the campaign screens (dashboard,
 * summary, list). It renders a small outlined button that opens a single popup
 * explaining every campaign metric. The term list defaults to the shared
 * METRIC_GLOSSARY but can be overridden per screen.
 */
@Component({
  selector: 'ipm-learn-terms-button',
  templateUrl: './learn-terms-button.component.html',
  styleUrls: ['./learn-terms-button.component.scss']
})
export class LearnTermsButtonComponent {
  @Input() label = '';
  @Input() title = 'Campaign Metrics';
  @Input() terms: InfoTerm[] = METRIC_GLOSSARY;

  @ViewChild('metricsInfoPop', { static: false }) metricsInfoTemplate: TemplateRef<any>;

  constructor(private commonService: CommonService) {}

  open(): void {
    const data = { title: this.title, icon: 'pi pi-info-circle', terms: this.terms };
    const className = this.commonService.getClassName('ipm-info-dialog-model');
    this.commonService.openModel(this.metricsInfoTemplate, data, className, false);
  }
}
